import { useContext } from 'react'

import { TemplatesContext } from './../context/TemplatesContext'

export const useTemplates = () => {
    const context = useContext(TemplatesContext)

    if (context === undefined) {
        throw new Error('TemplatesContext must be within TemplatesContextController')
    }

    return context
}
